import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
import { Table, Input, Select, Modal } from "antd";
import Map from "../../ui/map_full_detail";

import ChangePath from "../../services/ServiceApi";
import { Link } from "react-router-dom";
const { Option } = Select;

class AssetList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Asset List",
      tab: [{ text: "All Asset" }],
      active: 0,
      options: [
        { value: 1, text: "Job ID" },
        { value: 2, text: "Inform Date" },
      ],
      current_option: 1,
      columns: [
        {
          title: "Asset ID",
          dataIndex: "asset_id",
          key: "asset_id",
          render: (item) => (
            <Link to="/full_detail_job" className="c-blue text-underline">
              {item}
            </Link>
          ),
          sorter: (a, b) => a.asset_id - b.asset_id,
        },
        {
          title: "Group Type Name",
          dataIndex: "group_type_name",
          key: "group_type_name",
          sorter: (a, b) => a.group_type_name.length - b.group_type_name.length,
        },
        {
          title: "Asset Code",
          dataIndex: "asset_code",
          key: "asset_code",
          sorter: (a, b) => a.asset_code.length - b.asset_code.length,
        },
        {
          title: "Asset Type Name",
          dataIndex: "asset_type_name",
          key: "asset_type_name",
          sorter: (a, b) => a.asset_type_name.length - b.asset_type_name.length,
        },
        {
          title: "Asset Sub Type Name",
          dataIndex: "asset_sub_type_name",
          key: "asset_sub_type_name",
          sorter: (a, b) =>
            a.asset_sub_type_name.length - b.asset_sub_type_name.length,
        },
        {
          title: "Location Name",
          dataIndex: "location_name",
          key: "location_name",
          sorter: (a, b) => a.location_name.length - b.location_name.length,
        },
        {
          title: "Total Jobs",
          dataIndex: "total_jobs",
          key: "total_jobs",
          sorter: (a, b) => a.total_jobs - b.total_jobs,
        },
        {
          title: "Action",
          dataIndex: "asset_id",
          key: "asset_id",
          render: (item) => (
            <div>
              <button onClick={() => this.onView(item)}>
                <img src={ChangePath.absoluteUrl("/icon/view.svg")} alt="view-ic" />
              </button>
              <Link to="/all_jobs_asset">
                <img src={ChangePath.absoluteUrl("/icon/history.svg")} alt="his-ic" />
              </Link>
            </div>
          ),
        },
      ],
      data: [
        {
          asset_id: 4100001,
          group_type_name: "Digital Signage BTS 01",
          asset_code: "DGT-23523",
          asset_type_name: "Digital Signage",
          asset_sub_type_name: "Digital Signage BTS 01",
          location_name: "ลานน้ำพุ สยามพารากอน",
          total_jobs: 100,
        },
        {
          asset_id: 4100002,
          group_type_name: "Digital Signage BTS 01",
          asset_code: "DGT-23523",
          asset_type_name: "Digital Signage",
          asset_sub_type_name: "Digital Signage BTS 01",
          location_name: "ลานน้ำพุ สยามพารากอน",
          total_jobs: 100,
        },
        {
          asset_id: 4100003,
          group_type_name: "Digital Signage BTS 01",
          asset_code: "DGT-23523",
          asset_type_name: "Digital Signage",
          asset_sub_type_name: "Digital Signage BTS 01",
          location_name: "ลานน้ำพุ สยามพารากอน",
          total_jobs: 100,
        },
        {
          asset_id: 4100004,
          group_type_name: "Digital Signage BTS 01",
          asset_code: "DGT-23523",
          asset_type_name: "Digital Signage",
          asset_sub_type_name: "Digital Signage BTS 01",
          location_name: "ลานน้ำพุ สยามพารากอน",
          total_jobs: 100,
        },
        {
          asset_id: 4100005,
          group_type_name: "Digital Signage BTS 01",
          asset_code: "DGT-23523",
          asset_type_name: "Digital Signage",
          asset_sub_type_name: "Digital Signage BTS 01",
          location_name: "ลานน้ำพุ สยามพารากอน",
          total_jobs: 100,
        },
      ],
    };
  }

  componentDidMount() {
    document.title = this.state.title;
  }

  onView(id) {
    this.setState({
      visible: true,
      asset_id: id,
    });
  }

  renderModal() {
    const { visible, asset_id } = this.state;
    return (
      <Modal
        title={
          <span className="font-mont-b font16 c-blue text-uppercase">
            Asset ID : {asset_id}
          </span>
        }
        centered
        visible={visible}
        footer={null}
        closable={false}
        className="custom-modal-large"
      >
        <div className="row">
          <div className="col-6">
            <div className="mb-3">
              <img
                src={ChangePath.absoluteUrl("/img/img_job.png")}
                className="img-fluid"
                alt=""
              />
            </div>

            <div className="position-relative" style={{ height: "250px" }}>
              <Map
                center={{
                  lat: 13.764101,
                  lng: 100.54234,
                }}
                zoom={10}
              />
            </div>

            <div className="d-flex justify-content-between">
              <div>
                <span className="font-thai-b font18 d-block">Lat / Long</span>
                <span className="font-thai-sb font18 c-blue">
                  13.764101 / 100.54234
                </span>
              </div>

              <a
                target="_blank"
                href={
                  "https://maps.google.com/?q=" + 13.764101 + "," + 100.54234
                }
              >
                <img
                  src={ChangePath.absoluteUrl("/icon/google_map.svg")}
                  className="mr-2"
                />
                <span className="font-thai-b font16 c-blue text-underline">
                  Google map
                </span>
              </a>
            </div>
          </div>
          <div className="col-6">
            <div className="full-detail-job-des">
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Asset Code</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Asset Name</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Group Type</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Asset Type</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Asset Sub Type</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Model Number</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Social Number</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Date Install</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Warranty</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-red">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">MA Period</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Type Screen</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Format</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Resolution</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Eyeball / Month</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Width</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Length</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Height</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <span className="font-thai-b font18">Sqm</span>
                </div>
                <div className="col-7 pl-0">
                  <span className="font-thai-sb font18 c-blue">-</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 text-center">
          <button
            type="reset"
            onClick={() => this.setState({ visible: false })}
            className="btn btn-secondary"
          >
            Cancel
          </button>
        </div>
      </Modal>
    );
  }

  render() {
    const {
      title,
      active,
      tab,
      data,
      current_option,
      options,
      columns,
    } = this.state;
    return (
      <LayoutOperation active={3}>
        {this.renderModal()}
        <div className="wrapper-header d-flex align-items-center">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-3">
                <img
                  src={ChangePath.absoluteUrl("/icon/asset_list_white.svg")}
                  className="mr-3"
                />
                <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b font20">
                  {title}
                </h2>
              </div>
              <div className="col-6">
                <div className="row justify-content-center">
                  <div className="col-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="font-thai-b c-white font14">
                        Total Asset
                      </span>
                      <div className="stat d-flex align-items-center">
                        <span className="font-thai-b font30 c-white w-100 text-center">
                          600
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-3 offset-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="font-thai-b c-white font14">
                        Total Jobs
                      </span>
                      <div className="stat d-flex align-items-center">
                        <span className="font-thai-b font30 c-white w-100 text-center">
                          130
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3 text-right">
                <Link to="/" className="c-white font-mont-m font12">
                  <img
                    src={ChangePath.absoluteUrl("/icon/map.svg")}
                    className="mr-1"
                  />
                  Map
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper-body">
          <div className="container-fluid">
            <div className="mb-4 d-flex align-items-center justify-content-between">
              <div>
                <div className="d-flex">
                  <div className="mr-4">
                    <Input.Group compact>
                      <Select placeholder="Asset Group Type"></Select>
                      <Select placeholder="Asset Type"></Select>
                    </Input.Group>
                  </div>
                  <div>
                    <Input.Group compact>
                      <Select
                        value={current_option}
                        style={{ width: "180px" }}
                        onChange={this.handleOptionSearch}
                      >
                        {options.map((item, index) => (
                          <Option key={index} value={item.value}>
                            {item.text}
                          </Option>
                        ))}
                      </Select>

                      <Input.Search
                        placeholder="Search"
                        onSearch={(value) => console.log(value)}
                        style={{ width: "335px" }}
                        enterButton
                      />
                    </Input.Group>
                  </div>
                </div>
              </div>
              <div>
                <Link to="/addjob" className="btn btn-warning">
                  <img
                    src={ChangePath.absoluteUrl("/icon/add_job.svg")}
                    width="14"
                    className="mr-2"
                  />
                  Add Asset
                </Link>
              </div>
            </div>
            <div className="card-table-ma">
              <ul className="nav">
                {tab.map((item, index) => (
                  <li key={index} className="nav-item font12 font-mont-sb mr-1">
                    <a
                      className={
                        active === index ? "nav-link active" : "nav-link"
                      }
                      onClick={() => this.setState({ active: index })}
                    >
                      {item.text}
                    </a>
                  </li>
                ))}
              </ul>
              <div style={{ padding: "20px" }}>
                <Table rowKey="asset_id" columns={columns} dataSource={data} />
              </div>
            </div>
          </div>
        </div>
      </LayoutOperation>
    );
  }
}

export default AssetList;
